import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRouteInternal = ({ children }) => {
  const token = localStorage.getItem("internal_token");
  const userRaw = localStorage.getItem("internal_user");
  let user = null;
  try {
    user = userRaw ? JSON.parse(userRaw) : null;
  } catch (e) {
    user = null;
  }

  if (!token || !user) {
    return <Navigate to="/internal/login" replace />;
  }

  return children;
};

export default PrivateRouteInternal;
